import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleCollectionFetchPending,
  handleCollectionFetchRejected,
  handleCollectionFetchFulfilled,
} from "redux/helpers/fetching"
import { fetchDebtPayments } from "redux/features/debt_payment/debtPaymentThunk"

const debtPaymentAdapter = createEntityAdapter()
export const initialState = debtPaymentAdapter.getInitialState({
  fetchCollectionStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const debtPaymentSlice = createSlice({
  name: "debt-payments",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchDebtPayments.pending, (state) =>
        handleCollectionFetchPending(state),
      )
      .addCase(fetchDebtPayments.rejected, (state) =>
        handleCollectionFetchRejected(state),
      )
      .addCase(fetchDebtPayments.fulfilled, (state, { payload }) => {
        debtPaymentAdapter.setAll(state, payload)
        handleCollectionFetchFulfilled(state)
      })
  },
})

export const { selectAll: selectDebtPayments, selectTotal } =
  debtPaymentAdapter.getSelectors(
    (state: RootState) => state.features.debt_payment,
  )
export const selectFetchCollectionStatus = (state: RootState) =>
  state.features.debt_payment.fetchCollectionStatus

export default debtPaymentSlice.reducer
